import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-welcome-screen',
  templateUrl: './welcome-screen.component.html',
  styleUrls: ['./welcome-screen.component.scss'],
  standalone: true,
  imports: [FormsModule]
})
export class WelcomeScreenComponent {

  constructor(private router: Router){}

  createReport(reportName: string){
    this.router.navigate(['/rdsap/create-report'], { queryParams: { reportName }});
  }

  openAllSavedReports() {

  }

  openSettings() {
    this.router.navigate(['/rdsap/settings']);
  }
}
